"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlMultiBrand = void 0;
const brandUrl_1 = require("./brandUrl");
const config_1 = require("./config");
const isMultiBrand_1 = require("./isMultiBrand");
const getUrlMultiBrand = (availableBusinessUnits) => {
    var _a, _b;
    if (config_1.appConfig.isDevelopment) {
        return brandUrl_1.brandUrl.localhost;
    }
    let domain = '';
    if ((0, isMultiBrand_1.isMultiBrand)(availableBusinessUnits)) {
        domain = ((_a = config_1.envConfig.urlRedirectMultimarca) === null || _a === void 0 ? void 0 : _a.toString()) || '';
    }
    if (!domain) {
        domain = ((_b = config_1.envConfig.urlRedirect) === null || _b === void 0 ? void 0 : _b.toString()) || '';
    }
    return domain;
};
exports.getUrlMultiBrand = getUrlMultiBrand;
